module.exports = __webpack_public_path__ + "static/media/railcarConnect.b07cf102.svg";